module.exports = __webpack_public_path__ + "img/20190529161826QQ截图20190527165116.f4e30c13.png";